import type { AxiosError } from "axios";
import type { KeyedMutator } from "swr";
import type { Design } from "@/features/dmManagement/types";
import { GetDesignsAPI } from "@/features/dmManagement/api";
import { useApiClient } from "@/hooks/useApiClient";

interface UseDesignsParams {
  status?: string;
  ordering?: string;
}

interface UseDesignsReturn {
  designs: Design[] | undefined;
  isLoading: boolean;
  error: AxiosError | undefined;
  mutate: KeyedMutator<Design[]>;
}

/**
 * デザイン一覧を取得するカスタムフック。
 * ステータスやソート順のパラメータを指定して、フィルタリングされたデザイン一覧を取得できる。
 */
export const useDesigns = (params?: UseDesignsParams): UseDesignsReturn => {
  const { apiClient } = useApiClient();
  const { data, isLoading, mutate, error } = GetDesignsAPI(apiClient, params);

  return {
    designs: data,
    isLoading,
    error,
    mutate,
  };
};
